import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { globalPropTypes } from 'helpers';
import editReducer, { defaultState, setEditDataCreator, updateFieldCreator } from './reducer';
import {
  loadAllowedCbLevelDomainsCreator,
  loadClientMemberAssociationsByCBCreator,
  loadGlobalCisCertificatesAttributesCreator,
  setMaCisEditErrorsCreator,
  updateMaCisCreator,
} from '../../../../../store/actionsCreators';
import EditCertificate from '../../../../../shared/Cis/Certificates/Edit/EditCertificate';
import { getAssessorOptions } from '../../../../../api/services/cis';

function EditMaCertificate({
  certificate,
  errors,
  updateCertificate,
  removeError,
  levelDomains,
  certificationBodies,
  loadCertificatesAttributes,
  organizations,
  loadClientMemberAssociations,
  memberAssociations,
  userCb,
  languages,
  loadAllowedLevelDomains,
  allowedLevelDomains,
}) {
  const [state, dispatch] = useReducer(editReducer, defaultState);

  useEffect(() => {
    if (userCb && Number.isInteger(userCb)) {
      loadAllowedLevelDomains(userCb);
    }
  }, [loadAllowedLevelDomains, userCb]);

  useEffect(() => {
    if (certificate) {
      dispatch(setEditDataCreator(certificate));
    }
  }, [certificate]);

  if (!state.certificationBody && userCb && Number.isInteger(userCb)) {
    dispatch(updateFieldCreator({ name: 'certificationBody', value: userCb }));
  }

  const usableLevelDomains = allowedLevelDomains.length
    ? levelDomains.filter((ld) => allowedLevelDomains.includes(ld.value))
    : levelDomains;

  if (
    certificate?.levelDomain &&
    usableLevelDomains.findIndex((ld) => ld.value === certificate.levelDomain) === -1
  ) {
    usableLevelDomains.push({
      value: certificate.levelDomain.id,
      label: `${certificate.levelDomain.designation} (no longer allowed)`,
    });
  }

  return (
    <EditCertificate
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      updateCertificate={updateCertificate}
      removeError={removeError}
      levelDomains={usableLevelDomains}
      certificationBodies={certificationBodies}
      loadCertificatesAttributes={loadCertificatesAttributes}
      organizations={organizations}
      loadClientMemberAssociations={loadClientMemberAssociations}
      memberAssociations={memberAssociations}
      type="ma"
      languages={languages}
    />
  );
}

EditMaCertificate.propTypes = {
  certificate: PropTypes.shape({
    id: PropTypes.number,
    certificateHolder: PropTypes.number,
    levelDomain: PropTypes.number,
    certificationBody: PropTypes.number,
    issueDate: PropTypes.any,
    type: PropTypes.string,
    validUntil: PropTypes.any,
    certId: PropTypes.string,
    holderAuthorized: PropTypes.bool,
    visibility: PropTypes.bool,
    organization: PropTypes.number,
    memberAssociation: PropTypes.number,
  }),
  errors: PropTypes.shape({
    certificateHolder: PropTypes.string,
    certificateLevelDomain: PropTypes.string,
    certificationBody: PropTypes.string,
    issueDate: PropTypes.string,
    type: PropTypes.string,
    validUntil: PropTypes.string,
    certId: PropTypes.string,
    holderAuthorized: PropTypes.string,
    visibility: PropTypes.string,
    organization: PropTypes.string,
    memberAssociation: PropTypes.string,
  }),
  updateCertificate: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
  certificationBodies: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  levelDomains: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  loadCertificatesAttributes: PropTypes.func.isRequired,
};

EditMaCertificate.defaultProps = {
  certificate: null,
  errors: {},
};

const mapStateToProps = ({ ma, globals, user }) => ({
  certificate: ma.cis.certificates.profile,
  errors: ma.cis.certificates.editErrors,
  certificationBodies: globals.cis.certificationBodies,
  levelDomains: globals.cis.levelDomains,
  organizations: globals.cis.organizations,
  memberAssociations: globals.cis.clientMemberAssociations,
  userCb: user.user.memberAssociation?.certificationBody?.id,
  languages: globals.languages,
  allowedLevelDomains: ma.cis.allowedCbLevelDomains || [],
});

const mapDispatchToProps = (dispatch) => ({
  updateCertificate: (id, payload, history) =>
    dispatch(updateMaCisCreator(id, 'certificates', payload, history)),
  removeError: (payload) => dispatch(setMaCisEditErrorsCreator('certificates', payload)),
  loadCertificatesAttributes: () => dispatch(loadGlobalCisCertificatesAttributesCreator()),
  loadClientMemberAssociations: (payload) =>
    dispatch(loadClientMemberAssociationsByCBCreator(payload)),
  loadAllowedLevelDomains: (payload) => dispatch(loadAllowedCbLevelDomainsCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditMaCertificate);
